<div class="modal-header">
    <h5 class="modal-title">Chi Tiết Tác Giả</h5>
    <button type="button" class="close" aria-label="Đóng" (click)="closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">
    <h2>{{ writer?.name }}</h2>
    <p><strong>Ghi Chú:</strong> {{ writer?.note || 'Không có ghi chú nào' }}</p>
    <p><strong>Ngày Sinh:</strong> {{ writer?.dateOfBirth || 'Không rõ' }}</p>
    <p><strong>Đã Mất:</strong> {{ writer?.died === 'yes' ? 'Có' : 'Không' }}</p>
    <p *ngIf="writer?.died === 'yes'"><strong>Ngày Mất:</strong> {{ writer?.dateOfDeath || 'Không rõ' }}</p>
    <p><strong>Ấn Phẩm:</strong> {{ writer?.publications || 'Không có ấn phẩm nào được liệt kê' }}</p>
    <p><strong>Tiểu Sử:</strong> {{ writer?.bio || 'Không có tiểu sử nào' }}</p>
    <p><strong>Giải Thưởng:</strong> {{ writer?.award || 'Không có giải thưởng nào được liệt kê' }}</p>
    <p><strong>Tài Liệu Tham Khảo:</strong> {{ writer?.refrences || 'Không có tài liệu tham khảo nào' }}</p>
</div>

<div class="modal-footer">
    <div class="button-group">
        <button type="button" class="btn btn-outline-primary" (click)="openEditDialog(writer)">
          <i class="fas fa-edit"></i> Chỉnh Sửa
        </button>
        
        <button type="button" class="btn btn-outline-danger" (click)="deleteRow(writer)">
          <i class="fas fa-trash-alt"></i> Xóa
        </button>
        
        <button type="button" class="btn btn-outline-secondary" (click)="closeModal()">
          <i class="fas fa-times"></i> Đóng
        </button>
    </div>
</div>

